import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import './SideMenu.css';

// 부모에게서 필요한 모든 상태와 함수를 props로 전달받습니다.
function SideMenu({
    isOpen,
    onClose,
    isAuthenticated,
    isReady,
    onLoginClick,
    onProfileClick,
    onInboxClick,
    onRealtimeChatClick,
    onHomeClick,
    onNoticeClick,
    onSettingsClick,
    onFriendListClick
}) {
    // const navigate = useNavigate();

    const { currentUser } = useAuth();
    const isGuest = currentUser?.isAnonymous;

    // const handleLinkClick = (path) => {
    //     navigate(path);
    //     onClose(); // ★ 핵심: 여기서 메뉴를 닫아줍니다!
    // };

    return (
        <>
            <div
                className={`menu-overlay ${isOpen ? 'open' : ''}`}
                onClick={onClose}>
            </div>
            <div className={`side-menu ${isOpen ? 'open' : ''}`}>
                <button className="menu-close-button" onClick={onClose}>X</button>
                
                <div className="menu-items">
                    {/* 상단 메뉴 그룹 */}
                    <div className="menu-top">
                        {/* Home.jsx와 NoticeListPage.jsx의 버튼을 모두 포함 */}
                        <button className="menu-item" onClick={onHomeClick}>홈</button>
                        <button className="menu-item" onClick={onNoticeClick}>공지사항</button>
                        {isAuthenticated && isReady && (
                            <button className="menu-item" onClick={onFriendListClick}>친구 목록</button>
                        )}
                        {isAuthenticated && isReady && (
                            <button className="menu-item" onClick={onRealtimeChatClick}>실시간 채팅</button>
                        )}
                        {isAuthenticated && isReady && (
                            <button className="menu-item" onClick={onProfileClick}>프로필/지난대화</button>
                        )}
                        {isAuthenticated && isReady && (
                            <button className="menu-item" onClick={onInboxClick}>쪽지함</button>
                        )}
                        {isAuthenticated && isReady && (
                            <button className="menu-item" onClick={onSettingsClick}>설정</button>
                        )}
                        {!isAuthenticated && (
                            <button className="menu-item" onClick={onLoginClick}>간편 로그인</button>
                        )}
                    </div>

                    {/* 하단 메뉴 그룹 */}
                    <div className="menu-bottom">
                        {isAuthenticated && isGuest && (
                            // Case A: 게스트(비회원) -> '구글 연동' 버튼만 노출 (로그아웃/탈퇴 숨김)
                            <button 
                                className="menu-item google-link-menu-btn" 
                                onClick={onLoginClick} // 기존 로그인 팝업 함수 재사용
                            >
                                🔄 간편 로그인으로 전환
                            </button>
                        )}
                        {/* ▼▼▼ [삭제] 약관/개인정보 처리방침 링크 제거됨 ▼▼▼ */}
                    </div>
                </div>
            </div>
        </>
    );
}

export default SideMenu;